import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionButtonComponent } from './UI/action-button/action-button.component';
import { DaySelectorComponent } from './day-selector/day-selector.component';
import { FoodCategoryListComponent } from './food-category-list/food-category-list.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { PriceLabelComponent } from './UI/price-label/price-label.component';
import { QuantitySelectorComponent } from './UI/quantity-selector/quantity-selector.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import { SvgIconComponent } from './UI/svg-icon/svg-icon.components';
import { HeaderComponent } from './header/header.component';
import { DeliverySelectorComponent } from './UI/delivery-selector/delivery-selector.component';
import { BackgroundImageDirective } from '../directives/background-image.directive';
import { TranslateModule } from '@ngx-translate/core';
import { HiddenDirective } from '../directives/hidden.directive';
import { PipesModule } from '../pipes/pipes.module';
import { PaymentProcessingComponent } from './payment-processing/payment-processing.component';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';
import { DebugComponent } from './debug/debug.component';
import { InputComponent } from './UI/input/input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownComponent } from './UI/dropdown/dropdown.component';
import { ProductDescriptionComponent } from './product-description/product-description.component';
import { ProductListComponent } from './product-list/product-list.component';
import { IonicModule } from '@ionic/angular';
import { CartItemComponent } from './cart-item/cart-item.component';
import { ForgotPasswordConfirmationComponent } from './forgot-password-confirmation/forgot-password-confirmation.component';
import { OrderListComponent } from './my-orders/order-list.component';
import { OrderItemComponent } from './order-item/order-item.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrderTypeSwitchWarningComponent } from './order-type-switch-warning/order-type-switch-warning.component';
import { NoCreditCardAddedComponent } from './no-credit-card-added/no-credit-card-added.component';
import { WeekSwitcherComponent } from './week-switcher/week-switcher.component';
import { CheckboxComponent } from './UI/checkbox/checkbox.component';
import { RadioGroupComponent } from './UI/radio-group/radio-group.component';
import { SubsidyWalletComponent } from './subsidy-wallet/subsidy-wallet.component';
import { SubsidyInfoModalComponent } from './subsidy-info-modal/subsidy-info-modal.component';
import { ScannerComponent } from './scanner/scanner.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { OrderListItemHeaderComponent } from './order-list-item-header/order-list-item-header.component';
import { OrderListItemStatusComponent } from './order-list-item-status/order-list-item-status.component';
import { ScrollFloatHintComponent } from './UI/scroll-float-hint/scroll-float-hint.component';
import { TabsComponent } from './UI/tabs/tabs.component';
import { SettingsComponent } from './settings/settings.component';
import { TodaysDeliveriesComponent } from './todays-deliveries/todays-deliveries.component';
import { ListItemButtonComponent } from './list-item-button/list-item-button.component';
import { DeliveryForDateComponent } from './delivery-for-date/delivery-for-date.component';
import { DeliveryForDateStatusComponent } from './delivery-for-date-status/delivery-for-date-status.component';
import { NotificationBlockComponent } from './notification-block/notification-block.component';
import { GenericInfoPopupComponent } from './generic-info-popup/generic-info-popup.component';
import { SubsidyCodeActivationComponent } from './subsidy-code-activation/subsidy-code-activation.component';
import { DeleteProfileComponent } from './delete-profile/delete-profile.component';
import { ToastContainerComponent } from './util/toast-container/toast-container.component';
import { ScannedProductToastComponent } from './UI/scanned-product-toast/scanned-product-toast.component';
import { ManualBarcodeInputModalComponent } from './manual-barcode-input-modal/manual-barcode-input-modal.component';
import { ProductSearchModalComponent } from './product-search-modal/product-search-modal.component';
import { ModalGenericHeaderComponent } from './UI/modal-generic-header/modal-generic-header.component';
import { ProductSearchListItemComponent } from './product-search-list-item/product-search-list-item.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';

const exportsAndDeclarations = [
  ActionButtonComponent,
  DaySelectorComponent,
  FoodCategoryListComponent,
  ProductCardComponent,
  PriceLabelComponent,
  QuantitySelectorComponent,
  NavigationBarComponent,
  SvgIconComponent,
  HeaderComponent,
  DeliverySelectorComponent,
  PaymentProcessingComponent,
  OrderConfirmationComponent,
  DebugComponent,
  InputComponent,
  DropdownComponent,
  ProductDescriptionComponent,
  ProductListComponent,
  CartItemComponent,
  ForgotPasswordConfirmationComponent,
  OrderListComponent,
  OrderItemComponent,
  OrderDetailsComponent,
  OrderTypeSwitchWarningComponent,
  NoCreditCardAddedComponent,
  WeekSwitcherComponent,
  CheckboxComponent,
  RadioGroupComponent,
  SubsidyWalletComponent,
  SubsidyInfoModalComponent,
  ScannerComponent,
  OrderListItemHeaderComponent,
  OrderListItemStatusComponent,
  ScrollFloatHintComponent,
  TabsComponent,
  SettingsComponent,
  TodaysDeliveriesComponent,
  ListItemButtonComponent,
  DeliveryForDateComponent,
  DeliveryForDateStatusComponent,
  NotificationBlockComponent,
  GenericInfoPopupComponent,
  SubsidyCodeActivationComponent,
  DeleteProfileComponent,
  ToastContainerComponent,
  ScannedProductToastComponent,
  ManualBarcodeInputModalComponent,
  ProductSearchModalComponent,
  ModalGenericHeaderComponent,
  ProductSearchListItemComponent,
  LanguageSelectorComponent
];

@NgModule({
  declarations: [...exportsAndDeclarations],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    BackgroundImageDirective,
    HiddenDirective,
    TranslateModule,
    PipesModule,
    ReactiveFormsModule,
    IonicModule,
    ZXingScannerModule,
  ],
  exports: [...exportsAndDeclarations],
})
export class ComponentsModule {}
